export class Tokens {
  accessToken: string = "";
  refreshToken: string = "";
}

export class Login {
  productAccess: Array<Product> = [];
  ok: boolean = false;
  message: string = "";
  userNo: string = "";
  loginName: string = "";
  userFullName: string = "";
  firstName: string = "";
  lastName: string = "";
}

export class Product {
  productDesc: string = "";
  productID: number = 0;
  productIcon: string = "";
  productName: string = "";
  productStyle: string = "";
  productURL: string = "";
}
